import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

import getLocal from './getLocal';

momentDurationFormatSetup(moment);

const convertSecondsToMinutes = (seconds) => {
  const local = getLocal();
  return moment
    .duration(seconds, 'seconds')
    .locale(local)
    .format(`hh:mm:ss`, {trim: false});
};

export default convertSecondsToMinutes;
